import * as S from './clickToCallEnergyCardSubmitted.style';
import { organizeClickToCallSubmitted } from './clickToCallEnergyCardSubmitted.organize';
import { IClickToCallSubmitted } from './clickToCallEnergyCardSubmitted.models';
import { ImageAtoms } from '@vfit/shared/atoms';
import { useEffect } from 'react';
import { trackView } from '@vfit/shared/data-access';

export const ClickToCallCardSubmitted = ({
  entryPoint,
  taggingOpts,
  pageProduct,
  clickToCallData,
  phoneNumber,
}: IClickToCallSubmitted) => {
  const trimPhoneNumber = (phone: string) => `****${phone?.slice(4)}`;
  const CMSData = organizeClickToCallSubmitted(clickToCallData, trimPhoneNumber(phoneNumber));

  useEffect(() => {
    trackView({
      desc: entryPoint,
      ...(taggingOpts && { ...taggingOpts }),
      ...(pageProduct && {
        ...pageProduct,
      }),
      versatile_prop: 'new ctc',
      page_type: 'ctc cmn typ',
      page_name_override: `Privati:CTC:CMN:TYP`,
      ignore_base_page_name: true,
      event_name: ['journey_end', 'transaction_complete'],
      event_category: ['journey', 'sales'],
      journey_type: 'journey',
      journey_name: 'CTC',
      product_target_segment: 'consumer',
      page_section: 'fixed offers',
      page_subsection: 'catalogo',
    });
  }, []);

  return (
    <S.ClickToCallCardSecondStep>
      <S.ImageWrapper>
        <ImageAtoms image={CMSData?.successSubmission?.img || ''} nameCard="celebrate" />
      </S.ImageWrapper>
      <S.Title>{CMSData?.successSubmission?.headline}</S.Title>
      <S.Descriprition dangerouslySetInnerHTML={{ __html: CMSData?.successSubmission?.message }} />
    </S.ClickToCallCardSecondStep>
  );
};
